import { AppTrackingTransparency}  from 'capacitor-plugin-app-tracking-transparency'

import {APIError} from 'helpers/Rest';
import ServerActions from './ServerActions';

import { userSettingsSelector } from 'selectors/userSelector';

export function setUserSettings(settings) {
  return async (dispatch, getState, {api}) => {
    dispatch({type: 'user/settings/update', settings});
    const updatedSettings = userSettingsSelector(getState());
    const newSettings = await api.setUserSettings(updatedSettings);
    dispatch(ServerActions.receivedCurrentUser(newSettings));
  };
}

export const requestAppTrackingTransparency = () => async (_d, _g, {api}) => {
  const response = await AppTrackingTransparency.requestPermission();
  const do_not_track = (response?.status !== 'authorized');
  try {
    await api.updateUser({do_not_track});
  }  catch(e) {
    if (e instanceof APIError) {
      console.warn(e);
    } else {
      throw e;
    }
  }
}

export default {
  passwordReset: (email) => async (dispatch, _g, {api}) => {
    try {
      const passwordReset = await api.createPasswordReset(email);
      dispatch(ServerActions.receivedPasswordReset(passwordReset));
      return passwordReset;
    } catch(e) {
      if (e instanceof APIError) {
        const {json, body} = e?.response ?? {};
        dispatch(ServerActions.receivedLoginError(json ?? body));
      }

      throw e;
    }
  },

  changePassword: (new_password, authorization_token, email) => async (dispatch, _g, {api}) => {
    try {
      const password = await api.changePassword(new_password, authorization_token, email);
      const {access_token} = password ?? {};
      dispatch(ServerActions.receivedAccessToken(access_token));
      await api.initializeAppData();
    } catch(e) {
      if (e instanceof APIError) {
        const {json, body} = e?.response ?? {};
        dispatch(ServerActions.receivedLoginError(json ?? body));
      } else {
        throw e;
      }
    }
  },

  update: (user) => async (dispatch, _g, {api}) => {
    try {
      const updatedUser = await api.updateUser(user);
      dispatch(ServerActions.receivedCurrentUser(updatedUser));
    } catch(e) {
      if (e instanceof APIError) {
        const {json, body} = e?.response ?? {};
        dispatch(ServerActions.registrationError(json ?? body));
        dispatch(ServerActions.userUpdateError(json ?? body));
      } else {
        throw e;
      }
    }
  },

  requestDestroy: (email) => async (dispatch, _g, {api}) => {
    try {
      const request = await api.requestDestroyUser(email);
      dispatch(ServerActions.newDestroyRequest(request));
    } catch(e) {
      if (e instanceof APIError) {
        const {json, body} = e?.response ?? {};
        dispatch(ServerActions.receivedDestroyError(json ?? body));
      } else {
        throw e;
      }
    }
  },

  delete: () => async (dispatch, _g, {api}) => {
    try {
      const deletion = api.deleteUser();
      dispatch(ServerActions.destroyedUser(deletion));
    } catch(e) {
      if (e instanceof APIError) {
        const {json, body, statusCode} = e?.response ?? {};
        dispatch(ServerActions.receivedDestroyError(json ?? body, statusCode));
      } else {
        throw e;
      }
    }
  },

  deleteUnauthenticated: ({email, token}) => async (dispatch, _g, {api}) => {
    try {
      const request = api.updateDestroyRequests({email, token});
      dispatch(ServerActions.destroyedUser(request));
    } catch(e) {
      if (e instanceof APIError) {
        const {json, body} = e?.response ?? {};
        dispatch(ServerActions.receivedDestroyError(json ?? body));
      } else {
        throw e;
      }
    }
  },


  clearUserInfo() {
    return {type: 'CLEAR_USER_INFO'};
  },

  setSoilHelpSetting(soil_help) {
    return setUserSettings({soil_help});
  },

  requestAppTrackingTransparency,
};
